import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const PageHeaderWithActionsStyled = styled.div<{ $minHeight?: string }>`
  display: flex;
  width: 100%;
  min-height: ${(props) => props.$minHeight ?? '40px'};
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h1`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  margin: 0;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const TitleContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const InfoIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid
      ${(props) => props.theme.atlas.semantic.color.ui.focusRing};
    outline-offset: 2px;
  }
`;

export const InfoContentContainer = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  z-index: 100;
`;

export const HeaderRight = styled.div`
  display: flex;
  column-gap: 20px;
`;

export const Description = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  margin: 0;
  padding-top: 8px;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;
